module.exports = __webpack_public_path__ + "static/media/github-image.977c2c41.png";